import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { I18nextProvider } from 'react-i18next';
import i18n from './i18n';
import Home from './pages/Home';
import About from './pages/About';
import Resources from './pages/Resources';
import WorkPackages from './pages/WorkPackages';
import Deliverables from './pages/Deliverables';
import News from './pages/News';
import NewsDetail from './pages/NewsDetail';
import Events from './pages/Events';
import EventDetail from './pages/EventDetail';
import Contact from './pages/Contact';
import Login from './pages/Login';
import Materials from './pages/Materials';
import PracticeAbstracts from './pages/PracticeAbstracts';
import Newsletter from './pages/Newsletter';
import Partners from './pages/Partners';
import LegalNotice from './pages/LegalNotice';
import CookiePolicy from './pages/CookiePolicy';
import PrivacyPolicy from './pages/PrivacyPolicy';
import Dashboard from './components/Admin/Dashboard';
import AdminNews from './components/Admin/News';
import AdminCategories from './components/Admin/Categories';
import AdminEvents from './components/Admin/Events';
import AdminResources from './components/Admin/Resources';
import AdminDeliverables from './components/Admin/Deliverables';
import Comments from './components/Admin/Comments';
import Media from './components/Admin/Media';
import Settings from './components/Admin/Settings';
import AdminProfile from './components/Admin/AdminProfile';
import AdminChangePassword from './components/Admin/AdminChangePassword';
import AdminPartners from './components/Admin/Partners';
import ProtectedRoute from './components/ProtectedRoute';
import MetaTags from './components/MetaTags';
import './App.css';
import './aseets/css/fontawesome.min.css';
import './aseets/css/solid.min.css';
import './aseets/css/brands.min.css';
import './aseets/css/nucleo-outline.css';
import './aseets/css/jet-tricks-frontend.css';
import './aseets/css/blog-layouts-module.css';

import './aseets/css/custom-jet-blocks.css';
import './aseets/css/elementor-icons.min.css';
import './aseets/css/font-awesome.min.css';
import './aseets/css/frontend.min.css';
import './aseets/css/jet-blog.css';
import './aseets/css/jet-elements-skin.css';

import './aseets/css/jet-elements.css';
import './aseets/css/style.css';
import './aseets/css/style.min.css';
import './aseets/css/styles.css';
import './aseets/css/swiper.min.css';
import './aseets/css/theme.css';
import './aseets/css/slider-pro.min.css';
import './aseets/css/peel.min.css';
import { SettingsProvider } from './contexts/SettingsContext';

function App() {
  {/* 
     basename={document.baseURI.substring(
    document.baseURI.indexOf(window.location.origin) +
      window.location.origin.length,
    document.baseURI.lastIndexOf("/")
  )}
 */}
  return (
    <I18nextProvider i18n={i18n}>
      <SettingsProvider>
        <BrowserRouter   >
          <MetaTags />
          <Routes>
          <Route path="/" element={<Home />} />
        
        <Route path="/about" element={<About />} />
        <Route path="/resources" element={<Resources />} />
        <Route path="/workpackages" element={<WorkPackages />} />
        <Route path="/deliverables" element={<Deliverables />} />
        <Route path="/news" element={<News />} />
        <Route path="/news/:id" element={<NewsDetail />} />
        <Route path="/events" element={<Events />} />
        <Route path="/events/:id" element={<EventDetail />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/login" element={<Login />} />
        <Route path="/ressources" element={<Materials />} />
        <Route path="/partners" element={<Partners />} />
        <Route path="/legal-notice" element={<LegalNotice />} />
        <Route path="/cookie-policy" element={<CookiePolicy />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/admin/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
        <Route path="/admin/news" element={<ProtectedRoute><AdminNews /></ProtectedRoute>} />
        <Route path="/admin/categories" element={<ProtectedRoute><AdminCategories /></ProtectedRoute>} />
        <Route path="/admin/events" element={<ProtectedRoute><AdminEvents /></ProtectedRoute>} />
        <Route path="/admin/resources" element={<ProtectedRoute><AdminResources /></ProtectedRoute>} />
        <Route path="/admin/deliverables" element={<ProtectedRoute><AdminDeliverables /></ProtectedRoute>} />
        <Route path="/admin/comments" element={<ProtectedRoute><Comments /></ProtectedRoute>} />
        <Route path="/admin/media" element={<ProtectedRoute><Media /></ProtectedRoute>} />
        <Route path="/admin/partners" element={<ProtectedRoute><AdminPartners /></ProtectedRoute>} />
        <Route path="/admin/settings" element={<ProtectedRoute><Settings /></ProtectedRoute>} />
        <Route path="/admin/profile" element={<ProtectedRoute><AdminProfile /></ProtectedRoute>} />
        <Route path="/admin/change-password" element={<ProtectedRoute><AdminChangePassword /></ProtectedRoute>} />
        
        {/* Route de fallback pour les URLs non trouvées */}
        <Route path="*" element={<Home />} />
          </Routes>
        </BrowserRouter>
      </SettingsProvider>
    </I18nextProvider>
  );
}

export default App;
